export function CommandGroupTitle({ title }: { title: string }) {
  return (
    <div className="sticky top-0 -translate-y-px bg-white py-1 dark:bg-[#242424]">
      <div className="text-xs font-semibold text-gray-500 dark:text-gray-400">{title}</div>
    </div>
  );
}
